<div class="iframe-container">
  <pos-app-spinner [show]="loading"></pos-app-spinner>
  <iframe [src]="iframeUrl" title="ARB iframe" allowfullscreen="" (load)="onIframeLoad()" style="width: 100%; height: 100vh"> </iframe>
</div>
